import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    closeBtn: {
        background: 'transparent',
        border: 'none',
        height: '30px',
        position: 'absolute',
        right: '10px',
        top: '10px',
        width: '30px',
    },
    heading: {
        '& span svg': {
            width: '26px',
            height: '26px',
            marginRight: theme.spacing(1),
        },
    },
    currencyText: {
        '&': {
            padding: '0 0 10px',
            fontSize: '13px',
        },
        '& span': {
            display: 'inline',
            whiteSpace: 'nowrap',
            '& svg': {
                position: 'relative',
                top: '4px',
                marginRight: '2px',
            },
        },
    },
    remainingTime: {
        '&': {
            fontSize: '13px',
            marginBottom: '20px',
            border: '1px solid',
            borderRadius: '5px',
            width: '100%',
            padding: '20px',
            '> h2': {
                fontSize: '18px !important',
            },
            '> p, > h2': {
                margin: '0 !important',
            },
        },
    },
    fullWidth: {
        '&': {
            width: '100%',
        },
    },
}));
export default useStyles;
